<template>
  <div>
    <div class="ui form">
      <div class="fields">
        <div class="eleven wide field">
          <label>{{ $t("components.terminalForm.Descripcion") }}</label>
          <div class="ui input">
            <input type="text" v-model="currentController.description">
          </div>
        </div>
        <div class="five wide field">
          <label>{{ $t("components.terminalForm.Numero_serie") }}</label>
          <div class="ui input">
            <input type="text" v-model="currentController.serial" :disabled="!esRegistroNuevo">
          </div>
        </div>
      </div>
      <div class="fields">
        <div class="wide field" :class="{ three: (currentController.configuration.termtipo === '0'), four: (currentController.configuration.termtipo === '1') }">
          <label>{{ $t("components.terminalForm.Tipo_terminal") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="currentController.configuration.termtipo" :disabled="!esRegistroNuevo" @change="onChangeTipoTerminal">
              <option value="0">{{ $t("components.terminalForm.Tipo_terminal_maestro") }}</option>
              <option value="1">{{ $t("components.terminalForm.Tipo_terminal_esclavo") }}</option>
            </select>
          </div>
        </div>
        <div class="three wide field" v-show="currentController.configuration.termtipo === '0'">
          <label>{{ $t("components.terminalForm.Direccion_ip_terminal") }}</label>
          <div class="ui action input">
            <input id="inputTerminalIp" type="text" v-model="terminalIpMaestro">
          </div>
        </div>
        <div class="three wide field" v-show="currentController.configuration.termtipo === '0'">
          <label>{{ $t("components.terminalForm.Direccion_ip_nat") }}</label>
          <div class="ui action input">
            <input id="inputNATIp" :placeholder="$t('components.terminalForm.Opcional')" type="text" v-model="terminalNATIpMaestro">
          </div>
        </div>
        <div class="two wide field" v-show="currentController.configuration.termtipo === '0'">
          <label>{{ $t("components.terminalForm.Puerto") }}</label>
          <div class="ui action input">
            <input id="inputTerminalPort" type="number" v-model="terminalPortMaestro">
          </div>
        </div>
        <div class="seven wide field" v-show="currentController.configuration.termtipo === '1'">
          <label>{{ $t("components.terminalForm.Terminal_maestro_asociado") }}</label>
          <div class="ui action input">
            <select id="selectTerminalesMaestros" class="ui dropdown fluid" v-model="terminalIpEsclavo">
              <option v-bind:value="masterController.configuration.termip" v-bind:key="masterController._id" v-for="masterController in masterControllers">
                {{ masterController.description }}
              </option>
            </select>
          </div>
        </div>
        <div class="five wide field">
          <label>{{ $t("components.terminalForm.Id_lector_rfid") }}</label>
          <div class="ui action input" v-if="currentController.configuration.termtipo === '0'">
            <select id="selectNlectorMaestro" class="ui dropdown fluid" v-model="nLectorMaestro">
              <option value="-1">{{ $t('components.common.No') }}</option>
              <option value="0">{{ $t('components.common.Si') }}</option>
            </select>
          </div>
          <div class="ui action input" v-if="currentController.configuration.termtipo === '1'">
            <select id="selectNlectorEsclavo" class="ui dropdown fluid" v-model="nLectorEsclavo">
              <option v-bind:value="nLector" v-bind:key="index" v-for="(nLector,index) in $t('components.terminalForm.Ids_lector_rfid_esclavo')">
                {{ nLector }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="fields">
        <div class="four wide field">
          <label>{{ $t("components.terminalForm.Soporte_ble") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="soporteBle">
              <option value="0">{{ $t('components.common.No') }}</option>
              <option value="1">{{ $t('components.common.Si') }}</option>
            </select>
          </div>
        </div>
        <div class="four wide field" v-if="soporteBle === '1'">
          <label>{{ $t("components.terminalForm.Direccion_MAC_ble") }}</label>
          <div class="ui input">
            <input type="text" :placeholder="$t('components.terminalForm.Placeholder_direccion_mac')" v-model="direccionMACBle">
          </div>
        </div>
        <div class="eight wide field" v-if="soporteBle === '1'">
          <label>{{ $t("components.terminalForm.UUID_ble") }}</label>
          <div class="ui input">
            <input type="text" :placeholder="$t('components.terminalForm.Placeholder_uuid_ble')" v-model="uuidBle">
          </div>
        </div>
      </div>
      <div class="fields">
        <div class="four wide field">
        </div>
        <div class="twelve wide field" v-if="soporteBle === '1' && currentController.configuration.termtipo === '0'">
          <label>{{ $t("components.terminalForm.Clave_ble") }}</label>
          <div class="ui input">
            <input type="text" :placeholder="$t('components.terminalForm.Placeholder_clave_ble')" v-model="claveBle">
          </div>
        </div>
      </div>
      <div class="fields">
        <div class="ui styled accordion" style="width:100%">
          <div class="title active" style="background: #8bb040;color: white;">
            <i class="dropdown icon"></i>
            {{ $t("components.terminalForm.JefesEquipo") }}
            <span v-if="currentControllerMantainerUsers.length">( {{ currentControllerMantainerUsers.length }} )</span>
          </div>
          <div class="content active">
            <div v-for="currentControllerMantainerUser in currentControllerMantainerUsers" v-bind:key="currentControllerMantainerUser._id">
              <div class>
                <div class="active content" style="padding-top:0px; padding-bottom:0px">
                  <div class="fields">
                    <div class="fourteen wide field" >
                      <select class="ui dropdown fluid" v-bind:id="'selectedControllerMantainerUser' + currentControllerMantainerUser._id">
                        <option value="0">{{ $t("components.terminalForm.Seleccione_un_jefe_equipo") }}</option>
                        <option v-for="mantainerUser in allMantainerUsers" v-bind:key="mantainerUser._id" :value="mantainerUser._id">{{ mantainerUser.name + ' (' + mantainerUser.login + ')' }}</option>
                      </select>
                    </div>
                    <div class="two wide field" style="padding-top:5px;">
                      <button class="circular basic ui icon button red mini floated right" @click="removeMantainerUser(currentControllerMantainerUser._id)">
                        <i class="remove icon"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button class="circular ui icon button olive mini" @click="addMantainerUser()">
              <i class="icon add"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <h2 class="ui dividing header"></h2>
    <button class="ui olive labeled icon button" style="float:right" @click="save()">
      <i class="icon add"></i>{{ $t('components.common.Guardar') }}
    </button>
    <router-link class="item" to="/terminals">
      <button class="ui labeled icon button" style="float:right">
        <i class="remove icon"></i> {{ $t('components.common.Volver') }}
      </button>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';

export default {
  name: 'TerminalForm',
  data: function () {
    return {
      moment: Vue.moment,
      esRegistroNuevo: (this.$route.params.idTerminal == null),
      allMantainerUsers: [],
      currentControllerMantainerUsers: [],
      currentMantainerUser: { _id: '0' },
      terminalIpMaestro: '',
      terminalNATIpMaestro: '',
      terminalPortMaestro: 80,
      terminalIpEsclavo: '',
      nLectorMaestro: '-1',
      nLectorEsclavo: '1',
      soporteBle: '0',
      direccionMACBle: '',
      uuidBle: '',
      claveBle: '',
      currentController: { description: '', serial: '', configuration: { termtipo: '0', termip: '', nLector: '-1', soporteBle: '0', direccionMACBle: '', uuidBle: '', claveBle: '' } },
      masterControllers: [],
    };
  },
  computed: {
    isAdmin: function() {
      return this.$store.state.user.role === 0;
    },
  },
  methods: {
    calendarFormatDate: function (date, settings) {
      return this.moment(date).locale(this.$i18n.locale).format('LL');
    },
    refresh: function () {
      let getUrl = "/controller";

      if (this.$route.params.idTerminal != null) {
        getUrl += "/" + this.$route.params.idTerminal;
      }

      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get(getUrl).then(response => {
        if (response) {
          this.allMantainerUsers = response.data.mantainerUsers;
          this.masterControllers = response.data.masterControllers;

          if (response.data.controller != null) {
            this.currentController = response.data.controller;
            this.terminalIpMaestro = this.currentController.configuration.termip;
            this.terminalNATIpMaestro = this.currentController.configuration.natip;
            this.terminalPortMaestro = this.currentController.configuration.termport;
            this.terminalIpEsclavo = this.currentController.configuration.termip;
            this.soporteBle = this.currentController.configuration.soporteBle;
            this.direccionMACBle = this.currentController.configuration.direccionMACBle;
            this.uuidBle = this.currentController.configuration.uuidBle;
            this.claveBle = '';

            if (this.currentController.configuration.termtipo === '0') {
              this.nLectorMaestro = this.currentController.configuration.nLector;
            } else {
              this.nLectorEsclavo = this.currentController.configuration.nLector;
            }

            this.currentControllerMantainerUsers = response.data.controllerMantainerUsers;
          }

          Vue.nextTick(() => {
            this.currentControllerMantainerUsers.forEach((u) => {
              $('#selectedControllerMantainerUser' + u._id).dropdown('set selected', (u != null) ? u._id : 0);
            });

            $('.ui.dropdown').dropdown();
          });
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.terminalForm.Hay_un_error_obtener_datos_terminal'),
          text: e
        });
      });
    },
    onChangeTipoTerminal: function () {
      if (this.currentController.configuration.termtipo !== '0') {
        Vue.nextTick(() => {
          $('#selectTerminalesMaestros').dropdown('clear');
          $('#selectTerminalesMaestros').dropdown();
        });
      }
    },
    addMantainerUser: function () {
      this.currentControllerMantainerUsers.push({ _id: parseInt(Math.random() * 1000000) });

      Vue.nextTick(() => {
        $('.ui.dropdown').dropdown();
      });
    },
    removeMantainerUser: function (idMantainerUser) {
      this.currentControllerMantainerUsers = this.currentControllerMantainerUsers.filter((u) => u._id !== idMantainerUser);
    },
    save: function () {
      if (this.currentController.description.length === 0) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_descripcion') });
        return;
      }

      if (this.esRegistroNuevo) {
        if (this.currentController.serial.length === 0) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_numero_serie') });
          return;
        }

        if ((this.currentController.configuration.termtipo !== '0') && (this.currentController.configuration.termtipo !== '1')) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_tipo_terminal') });
          return;
        }
      }

      if (this.currentController.configuration.termtipo === '0') {
        if ((this.soporteBle === '1') && (!(/^([0-9a-fA-F]{2}[:-]){5}([0-9a-fA-F]{2})$/.test(this.direccionMACBle)))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_direccion_MAC') });
          return;
        }

        if ((this.soporteBle === '1') && (this.uuidBle != null) && (this.uuidBle !== "") && (!(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(this.uuidBle)))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_uuid') });
          return;
        }

        if (this.esRegistroNuevo && (this.soporteBle === '1') && (!(/^[0-9a-fA-F]{32}$/.test(this.claveBle)))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_clave_cifrado') });
          return;
        }

        if (!this.esRegistroNuevo && (this.soporteBle === '1') && (this.claveBle != null) && (this.claveBle !== "") && (!(/^[0-9a-fA-F]{32}$/.test(this.claveBle)))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_clave_cifrado') });
          return;
        }

        this.currentController.configuration.termip = this.terminalIpMaestro;
        this.currentController.configuration.natip = this.terminalNATIpMaestro;
        this.currentController.configuration.termport = this.terminalPortMaestro;
        this.currentController.configuration.nLector = this.nLectorMaestro;
        this.currentController.configuration.soporteBle = this.soporteBle;
        this.currentController.configuration.direccionMACBle = this.direccionMACBle;
        this.currentController.configuration.uuidBle = this.uuidBle;
        this.currentController.configuration.claveBle = this.claveBle;

        if (!(/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(this.currentController.configuration.termip))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_direccion_ip_terminal'), text: this.$i18n.t('components.terminalForm.Introducir_direccion_ip_detalle') });
          return;
        }

        if ((this.currentController.configuration.natip != null) && (this.currentController.configuration.natip !== '')) {
          if (!(/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(this.currentController.configuration.natip))) {
            this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_direccion_ip_nat'), text: this.$i18n.t('components.terminalForm.Introducir_direccion_ip_detalle') });
            return;
          }
        }

        if (this.currentController.configuration.termport < 1 || this.currentController.configuration.termport > 65535) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_puerto'), text: this.$i18n.t('components.terminalForm.Introducir_puerto_detalle') });
          return;
        }

        if ((this.currentController.configuration.nLector !== '-1') && (this.currentController.configuration.nLector !== '0')) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_lector_rfid_maestro') });
          return;
        }

        if ((this.currentController.configuration.nLector !== '-1') && (this.currentController.configuration.nLector !== '0')) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_lector_rfid_maestro') });
          return;
        }
      } else {
        if ((this.soporteBle === '1') && (!(/^([0-9a-fA-F]{2}[:-]){5}([0-9a-fA-F]{2})$/.test(this.direccionMACBle)))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_direccion_MAC') });
          return;
        }

        if ((this.soporteBle === '1') && (this.uuidBle != null) && (this.uuidBle !== "") && (!(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(this.uuidBle)))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_uuid') });
          return;
        }

        this.currentController.configuration.termip = this.terminalIpEsclavo;
        this.currentController.configuration.soporteBle = this.soporteBle;
        this.currentController.configuration.direccionMACBle = this.direccionMACBle;
        this.currentController.configuration.uuidBle = this.uuidBle;
        this.currentController.configuration.claveBle = "";
        
        for(const masterController of this.masterControllers) {
          if (masterController.configuration.termip === this.terminalIpEsclavo) {
            this.currentController.configuration.termport = masterController.configuration.termport;
            break;
          }
        }

        this.currentController.configuration.nLector = this.nLectorEsclavo;

        if ((this.currentController.configuration.termip == null) || (this.currentController.configuration.termip.length === 0)) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_terminal_maestro') });
          return;
        }

        if (this.$i18n.t('components.terminalForm.Ids_lector_rfid_esclavo').find((nLectorAvailable) => nLectorAvailable === this.currentController.configuration.nLector) == null) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.terminalForm.Introducir_lector_rfid_esclavo') });
          return;
        }
      }

      // obtenemos la lista de usuarios (descartando los no seleccionados y los repetidos)
      const newMantainerUsers = [];
      for (let i = 0; i < this.currentControllerMantainerUsers.length; i++) {
        const idMantainerUser = (($('#selectedControllerMantainerUser' + this.currentControllerMantainerUsers[i]._id).val() == null) || ($('#selectedControllerMantainerUser' + this.currentControllerMantainerUsers[i]._id).val() === 0)) ? null : $('#selectedControllerMantainerUser' + this.currentControllerMantainerUsers[i]._id).val();
        const selectedMantainerUser = this.allMantainerUsers.find((u) => u._id === idMantainerUser);

        if ((selectedMantainerUser != null) && (newMantainerUsers.find((u) => u._id === selectedMantainerUser._id) == null)) {
          newMantainerUsers.push(selectedMantainerUser);
        }
      }
      this.currentControllerMantainerUsers = newMantainerUsers;

      if (!this.esRegistroNuevo) {
        axios.put('/controller/' + this.currentController._id, { controller: this.currentController, controllerMantainerUsers: this.currentControllerMantainerUsers }).then(response => {
          this.$swal.fire(
            this.$i18n.t('components.terminalForm.Save_Ok_Title'),
            this.$i18n.t('components.terminalForm.Save_Ok_Text'),
            'success'
          );

          this.$router.push({ name: 'terminals' });
        }).catch(e => {
          if (e.response.status === 400) {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.terminalForm.Hay_un_error_actualizar_datos_terminal'),
              text: this.$i18n.t('components.terminalForm.Hay_un_error_actualizar_datos_terminal_' + e.response.data.statusCode)
            });
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.terminalForm.Hay_un_error_actualizar_datos_terminal'),
              text: e
            });
          }
        });
      } else {
        axios.post('/controller', { controller: this.currentController, controllerMantainerUsers: this.currentControllerMantainerUsers }).then(response => {
          this.$swal.fire(
            this.$i18n.t('components.terminalForm.Save_Ok_Title'),
            this.$i18n.t('components.terminalForm.Save_Ok_Text'),
            'success'
          );

          this.$router.push({ name: 'terminals' });
        }).catch(e => {
          if (e.response.status === 400) {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.terminalForm.Hay_un_error_actualizar_datos_terminal'),
              text: this.$i18n.t('components.terminalForm.Hay_un_error_actualizar_datos_terminal_' + e.response.data.statusCode)
            });
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.terminalForm.Hay_un_error_actualizar_datos_terminal'),
              text: e
            });
          }
        });
      }
    }
  },
  mounted: function () {
    this.refresh();

    setTimeout(() => {
      $('.accordion').accordion({
        exclusive: false,
        selector: {
          trigger: '.title'
        }
      });

      $('.ui.dropdown').dropdown();
    }, 500);
  }
};
</script>
